/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_similarGridItems = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsFooter_similarGridItems">;
    readonly " $refType": "PdpRespContainer_similarGridItems";
};
export type PdpRespContainer_similarGridItems$data = PdpRespContainer_similarGridItems;
export type PdpRespContainer_similarGridItems$key = {
    readonly " $data"?: PdpRespContainer_similarGridItems$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_similarGridItems">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_similarGridItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_similarGridItems",
      "args": null
    }
  ]
};
(node as any).hash = '9592948420bef0dc097ca93ed76bec16';
export default node;
